import { Accordion, Box, Card, Grid, InputText, Maps } from "#/atoms";
import { forwardRef, memo, useCallback, useEffect, useImperativeHandle } from "react";

import { CardHandle } from "../Cards.interface";
import { DESKTOP_SPACING } from "@/theme";
import { HeadingIcon } from "#/molecules/HeadingIcon";
import { PropertyAddressCardProps } from "./PropertyAddress.interface";
import { useMaps } from "@/hooks";

const PropertyAddressCard = forwardRef<CardHandle, PropertyAddressCardProps>(
 ({
  accordionState = 'open',
  addressString,
  flat,
  isReadOnly,
}, ref) => {
  const { address, mapsAddress, onBlur, onChange, setAddress } = useMaps(addressString.value);
  
  useImperativeHandle(ref, () => ({
    validate: () => {
      addressString.validate();
      const isValid = addressString.error === null;

      return { isValid: isValid, validationErrors: isValid ? [] : [ addressString.error ?? '' ]};
    }
  }));

  useEffect(() => {
    if (addressString.value) {
      setAddress(addressString.value);
    }
  }, [addressString.value]);

  const handleAddressChange = useCallback((ev: React.ChangeEvent<HTMLInputElement>) => {
    addressString.onChange(ev)
    onChange(ev);
  }, []);

  const handleMapsAddressChange = useCallback((addr: string) => {
    addressString.setValue(addr)
    setAddress(addr);
  }, []);

  const description = 'Start typing the address or postcode to search.';
  
  return (
    <Card padding="0">
      <Box padding={`${DESKTOP_SPACING.EL}px`}>
        <Accordion
          header={
            <HeadingIcon
              description={accordionState === 'open' ? description : ''}
              icon="location"
              title="Address Details"
            />
          }
          headerMargin={`${DESKTOP_SPACING.XXXL}px`}
          showArrow
          state={accordionState}
        >
          <Grid gridTemplateColumns="45% 55%" columnGap={DESKTOP_SPACING.XL} margin="0">
            <Box>
              <InputText
                type="text"
                label="Full Property Address"
                name="gmaps"
                value={address}
                onBlur={onBlur}
                onChange={handleAddressChange}
                readOnly={isReadOnly}
                errorMessage={addressString.error || ''}
                state={addressString.error ? 'error' : 'idle' }
                required={true}
              />
              <InputText
                type="text"
                label="Flat/Door number or letter"
                value={flat.value}
                onChange={flat.onChange}
                readOnly={isReadOnly}
              />
              {/* <InputText
                type="text"
                label="Door Number"
                value={doorNumber.value}
                onChange={doorNumber.onChange}
                readOnly={isReadOnly}
                style={{display: 'none'}}
              /> */}
            </Box>
            <Box>
              <Maps address={mapsAddress} canPlaceMarker={!isReadOnly} onAddressChanged={handleMapsAddressChange} />
            </Box>
          </Grid>
        </Accordion>
      </Box>
    </Card>
  );
}
);

PropertyAddressCard.displayName = 'PropertyAddressCard';

export default memo(PropertyAddressCard);